import { render } from "./Data.vue?vue&type=template&id=68126406"
import script from "./Data.vue?vue&type=script&lang=js"
export * from "./Data.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/qc-getplaces-staging-gcs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__